import { configure } from 'vee-validate';
import i18n from '../vue-i18n';
import './rules';

configure({
  defaultMessage: (field, values) => {
    // eslint-disable-next-line no-param-reassign
    values._field_ = i18n.t(`field.${field}`);

    return i18n.t(`validation.${values._rule_}`, values);
  },
});
